import './services.checkout.js.coffee'
import './services.logger'
import './multi_checkout/services.multi-checkout'
import './services.cart'
import loggerService from '../../utils/loggerService'

import { CART_TRACKER_TYPE_FOR_V1_AND_V2 } from '../constants/tracker';
import { CHECKOUT_EVENTS } from '../constants/angular-events';
import { COLLAPSE_STATUS } from '../constants/components/collapse-block-status';
import { delayRedirect } from '../../utils/redirect';
import {
  GENERAL_DISCOUNT_TYPES,
  BUNDLE_GROUP_DISCOUNT_TYPES,
  BUNDLE_PRICING_DISCOUNT_TYPES,
  BUY_AND_GET_DISCOUNT_TYPES,
  REWARD_CAMPAIGN_TYPES,
} from '../constants/promotion';

app.directive("checkoutCartPromotions", [
  '$rootScope'
  '$timeout'
  '$http'
  '$compile'
  'checkoutService'
  '$injector'
  'multiCheckoutService'
  'cartService'
  'trackerService'
  (
    $rootScope
    $timeout
    $http
    $compile
    checkoutService
    $injector
    multiCheckoutService
    cartService
    trackerService
  ) ->
    {
      restrict: 'A'
      link: (scope, element, attrs) ->
        scope.promotionCollapseStatus = COLLAPSE_STATUS.EXPANDED;
        scope.$on CHECKOUT_EVENTS.CART.PROMOTIONS.RELOAD, () ->
          element.addClass "checkout-section-loading"
          checkoutService.requestPartial('cart', 'promotions')
            .then (res) ->
              element.html($compile(presetCollapsed(res.data))(scope))
            .catch (error) ->
              loggerService.error(new Error('Unable to load cart promotions'), { context: { error } })
            .finally () ->
              element.removeClass "checkout-section-loading"
              scope.$emit CHECKOUT_EVENTS.CART.CONTENT.LOADED
              # to ensure the DOM in element is fully rendered
              $timeout(() ->
                onTrackPromotionReminderShow()
              , 0)

        element.on "destroy", (() -> element.off()) # Unbind events
        element.on "click", ".btn-remove-coupon", (event) ->
          $container = angular.element(event.currentTarget).closest(".promotion")
          code = $container.attr("data-coupon-code")
          return if _.isEmpty(code)
          $rootScope.$broadcast CHECKOUT_EVENTS.CART.COUPON.REMOVE, code

        presetCollapsed = (htmlString) ->
          return htmlString unless showCollapseBlock()

          $content = $('<div>' + htmlString + '</div>');
          $content.find('collapse-block').attr('collapse-status', scope.promotionCollapseStatus);

          return $content.html();

        showCollapseBlock = () ->
          return multiCheckoutService.isEnabled() && $injector.has('showCollapseBlock') && $injector.get('showCollapseBlock');

        scope.onPromotionCollapseChange = ({ collapseStatus }) ->
          scope.promotionCollapseStatus = collapseStatus

        # on initialize
        $timeout(() ->
          scope.$emit CHECKOUT_EVENTS.CART.CONTENT.LOADED
          onTrackPromotionReminderShow()
        , 100)

        scope.removeCustomDiscount = (item_id) ->
          cartService.removeCustomDiscountItem(item_id).then () ->
            $rootScope.$broadcast CHECKOUT_EVENTS.CART.PROMOTIONS.CHANGED

        transformToTrackerPromotionType = ({ discountType, isApplied }) ->
          isRewardCampaign = Object.values(REWARD_CAMPAIGN_TYPES).includes(discountType)
          isFreeShipping = discountType == GENERAL_DISCOUNT_TYPES.freeShipping

          switch(true)
            when discountType == 'continue_shopping'
              return 'order_level_discount_non_applied'
            when isRewardCampaign && isApplied
              return 'item_level_reward_applied'
            when isRewardCampaign && !isApplied
              return 'item_level_reward_non_applied'
            when isFreeShipping && isApplied
              return 'item_level_free_shipping_applied'
            when isFreeShipping && !isApplied
              return 'item_level_free_shipping_non_applied'
            when isApplied
              return 'item_level_promotion_applied'
            else
              return 'item_level_promotion_non_applied'

        getTrackerPromotionType = (link) ->
          discountType = link.getAttribute('data-discount-type')
          isApplied = link.getAttribute('data-is-applied-promotion') is 'true'

          return transformToTrackerPromotionType({ discountType, isApplied })

        onTrackPromotionReminderShow = () ->
          cartPromotionItemLinks = element.find('.cart-promotion__item-link')

          if cartPromotionItemLinks.length > 0
            trackerPromotionTypes = new Set()

            cartPromotionItemLinks.each((_index, link) ->
              trackerPromotionTypes.add(getTrackerPromotionType(link))
            )

            trackerService.track({
              type: CART_TRACKER_TYPE_FOR_V1_AND_V2.PROMOTION_REMINDER_SHOW,
              data: {
                scope: 'shop',
                event_category: 'Cart',
                promotion_types: Array.from(trackerPromotionTypes),
              },
            })

        scope.onPromotionLinkClick = (event) ->
          trackerPromotionType = getTrackerPromotionType(event.currentTarget)

          trackerService.track({
            type: CART_TRACKER_TYPE_FOR_V1_AND_V2.PROMOTION_REMINDER_CLICK,
            data: {
              scope: 'shop',
              event_category: 'Cart',
              promotion_type: trackerPromotionType,
            },
          })

          # use default behavior if open in new tab
          if event.metaKey || event.ctrlKey
            return true

          event.preventDefault()

          delayRedirect(event.currentTarget.href)
    }
])
